import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  ${({ theme }) => css`
    display: block;
    padding: ${theme.layout.chat_header_height} 16px
      ${theme.layout.chat_navigation_height};

    & > div {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin: 20px 0 30px;
    }
  `}
`;

export const ButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  text-align: center;
`;

export const Button = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 44px;
    padding: 10px 0 10px 10px;
    color: ${theme.content.content_light_5};
    ${theme.fontStyle.text.body16_medium}
  `}
`;
